module.exports = __webpack_public_path__ + "img/etherum.58f92e86.png";